import { Controller } from "@hotwired/stimulus"
import { Director, View } from "@millicast/sdk"

export default class extends Controller {
  static targets = ["count"]
  static values = { streamAccountId: String, streamName: String }

  #millicastView

  connect() {
    const tokenGenerator = () =>
      Director.getSubscriber({
        streamAccountId: this.streamAccountIdValue,
        streamName: this.streamNameValue
      })

    this.#millicastView = new View(
      undefined, // The first argument is deprecated.
      tokenGenerator
    )
    this.#millicastView.on("broadcastEvent", event => {
      this.countTarget.textContent = event.data.viewercount
    })

    this.#millicastView.connect({ events: ["viewercount"] })
  }

  disconnect() {
    this.#millicastView.stop()
  }
}
